import de from '@vueform/vueform/locales/de';
import en from '@vueform/vueform/locales/en';
import hu from '@vueform/vueform/locales/hu';
import bootstrap from '@vueform/vueform/dist/bootstrap.vue2';
import { defineConfig } from '@vueform/vueform';

export default defineConfig({
    theme: bootstrap,
    locales: {
        en,
        de,
        sl: en, // not supported
        hu,
        hr: en, // not supported
    },
    locale: 'en',
});